export const TRANSALTE_MAP = {
  ar: {
    featured: '\u200Fمميزة', // 精选（RTL处理）
    shoes: '\u200Fأحذية' // 鞋子（RTL处理）
  },
  de: {
    featured: 'Ausgewählte',
    shoes: 'Schuhe'
  },
  en: {
    featured: 'Featured',
    shoes: 'Shoes'
  },
  es: {
    featured: 'Destacados',
    shoes: 'Zapatos'
  },
  fa: {
    featured: '\u200Fبرگزیده', // 精选（RTL处理）
    shoes: '\u200Fکفش‌ها' // 鞋子（RTL处理）
  },
  fr: {
    featured: 'Sélection',
    shoes: 'Chaussures'
  },
  hi: {
    featured: 'चुनिंदा',
    shoes: 'जूते'
  },
  it: {
    featured: 'In Evidenza',
    shoes: 'Scarpe'
  },
  ja: {
    featured: '特選',
    shoes: 'シューズ'
  },
  ko: {
    featured: '추천',
    shoes: '신발'
  },
  ms: {
    featured: 'Terpilih',
    shoes: 'Kasut'
  },
  nl: {
    featured: 'Uitgelichte',
    shoes: 'Schoenen'
  },
  pl: {
    featured: 'Wyróżnione',
    shoes: 'Buty'
  },
  pt: {
    featured: 'em Destaque',
    shoes: 'Sapatos'
  },
  ru: {
    featured: 'Избранная',
    shoes: 'обувь'
  },
  sw: {
    featured: 'Vilivyochaguliwa',
    shoes: 'Viatu'
  },
  th: {
    featured: 'คัดสรร',
    shoes: 'รองเท้า'
  },
  tr: {
    featured: 'Öne Çıkan',
    shoes: 'Ayakkabılar'
  },
  vi: {
    featured: 'Nổi Bật',
    shoes: 'Giày'
  },
  zh: {
    featured: '精选',
    shoes: '鞋子'
  }
}

export const FEATURED_LIST = [
  {
    path: '/featured/shoes',
    name: 'shoes',
    label: {
      ar: '\u200Fأحذية مميزة', // 阿拉伯语（RTL处理）
      de: 'Ausgewählte Schuhe', // 德语
      en: 'Featured Shoes', // 英语
      es: 'Zapatos Destacados', // 西班牙语
      fa: '\u200Fکفش‌های برگزیده', // 波斯语（RTL处理）
      fr: 'Chaussures Sélection', // 法语
      hi: 'चुनिंदा जूते', // 印地语
      it: 'Scarpe in Evidenza', // 意大利语
      ja: '特選シューズ', // 日语
      ko: '추천 신발', // 韩语
      ms: 'Kasut Terpilih', // 马来语
      nl: 'Uitgelichte Schoenen', // 荷兰语
      pl: 'Wyróżnione Buty', // 波兰语
      pt: 'Sapatos em Destaque', // 葡萄牙语
      ru: 'Избранная обувь', // 俄语
      sw: 'Viatu Vilivyochaguliwa', // 斯瓦希里语
      th: 'รองเท้าคัดสรร', // 泰语
      tr: 'Öne Çıkan Ayakkabılar', // 土耳其语
      vi: 'Giày Nổi Bật', // 越南语
      zh: '精选鞋子' // 中文
    }
  }
]
